<div class="collaterateInfo-message{{#if isSuccess}} isSuccess{{/if}}{{#if isInfo}} isInfo{{/if}}{{#if isWarning}} isError{{/if}}" role="alert">
    {{#if timestamp}}<time class="collaterateInfo-message-time" datetime="{{timestamp}}">{{timestamp}}</time>{{/if}}
    <p class="collaterateInfo-message-bd">{{body}}</p>
    <span class="collaterateInfo-message-close js-close-message" aria-label="Dismiss" role="button"></span>
</div>
